// src/app/u3141LandRegister/components/form/u3141ChildLotChain/U3141UseViewDocumentHandlers.ts
export interface U3141UseViewDocumentHandlersParams<T = unknown> {
  doViewDocumentFn: (documentId: string) => Promise<unknown>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: unknown }) => void;
}

// Return type for useU3141UseViewDocumentHandlers hook
export interface U3141UseViewDocumentHandlersReturn {
  viewDocument: (documentId: string) => void;
}

// Handlers for viewing land register document
export function useU3141UseViewDocumentHandlers<T extends { id: string } = { id: string }>({ doViewDocumentFn, onSuccess, onError }: U3141UseViewDocumentHandlersParams<T>): U3141UseViewDocumentHandlersReturn {
  const viewDocument = async (documentId: string) => {
    try {
      const response = (await doViewDocumentFn(documentId)) as { data: { result: T } };
      const row: T = response.data.result;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { viewDocument };
}
